// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"43fc0495","770":"660bae03"}[chunkId] + ".chunk.js";
};